import { render, staticRenderFns } from "./tagsListSearch.vue?vue&type=template&id=6e7853b2&scoped=true"
import script from "./tagsListSearch.vue?vue&type=script&lang=js"
export * from "./tagsListSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7853b2",
  null
  
)

export default component.exports